export default function youtubeParser(url: string): string | null {
	var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
	var match = url.match(regExp);

	if (match && match[7].length == 11) {
		return match[7];
	}
	
	return null
}